import { createStore } from 'vuex'
import axios from '@/utils/request'

// 定义存储键名常量
const STORAGE_KEYS = {
  USER_ID: 'smartdentistui_userId',
  USERNAME: 'smartdentistui_username',
  TOKEN: 'smartdentistui_token',
  USER_INFO: 'smartdentistui_userInfo',
  STATE: 'smartdentistui_state' // 完整状态存储键
}

// 从localStorage加载完整状态
const loadStateFromStorage = () => {
  try {
    // 尝试加载完整状态
    const serializedState = localStorage.getItem(STORAGE_KEYS.STATE)
    if (serializedState) {
      const state = JSON.parse(serializedState)
      return state
    }
  } catch (error) {
    console.error('加载状态失败:', error)
  }
  
  // 降级方案：单独加载关键信息
  return {
    userId: localStorage.getItem(STORAGE_KEYS.USER_ID) || null,
    username: localStorage.getItem(STORAGE_KEYS.USERNAME) || '',
    token: localStorage.getItem(STORAGE_KEYS.TOKEN) || '',
    userInfo: null,
    isLoading: false
  }
}

export default createStore({
  // 使用从localStorage恢复的状态初始化store
  state: loadStateFromStorage(),
  getters: {
    isLogin: state => !!state.userId,
    // 可以添加更多的getter用于获取用户相关信息
    userFullInfo: state => {
      return {
        userId: state.userId,
        username: state.username,
        ...state.userInfo
      }
    }
  },
  mutations: {
    setUser(state, { userId, username, token, userInfo = null }) {
      state.userId = userId
      state.username = username
      state.token = token
      if (userInfo) {
        state.userInfo = userInfo
      }
      // 持久化到localStorage
      localStorage.setItem(STORAGE_KEYS.USER_ID, userId)
      localStorage.setItem(STORAGE_KEYS.USERNAME, username)
      localStorage.setItem(STORAGE_KEYS.TOKEN, token)
      if (userInfo) {
        localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(userInfo))
      }
    },
    clearUser(state) {
      state.userId = null
      state.username = ''
      state.token = ''
      state.userInfo = null
      // 清除localStorage
      localStorage.removeItem(STORAGE_KEYS.USER_ID)
      localStorage.removeItem(STORAGE_KEYS.USERNAME)
      localStorage.removeItem(STORAGE_KEYS.TOKEN)
      localStorage.removeItem(STORAGE_KEYS.USER_INFO)
      localStorage.removeItem(STORAGE_KEYS.STATE)
    },
    setLoading(state, status) {
      state.isLoading = status
    },
    updateUserInfo(state, info) {
      state.userInfo = { ...state.userInfo, ...info }
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
      commit('setLoading', true)
      try {
        const res = await axios.post('/api/login/', { username, password })
        // 确保响应数据格式正确
        if (res && res.results) {
          commit('setUser', {
            userId: res.results.user_id,
            username: res.results.username,
            token: res.Authorization || res.results.token,
            userInfo: res.results
          })
        }
        return res
      } catch (error) {
        console.error('登录失败:', error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
    async register({ commit }, { username, password, yaoqingma }) {
      commit('setLoading', true)
      try {
        const res = await axios.post('/api/user/', { 
          username, 
          password, 
          yaoqingma: yaoqingma || '' 
        })
        return res
      } catch (error) {
        console.error('注册失败:', error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
    // 确保logout返回Promise
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('clearUser')
        resolve()
      })
    },
    // 可以添加一个验证token有效性的action
    async validateToken({ commit, state }) {
      if (!state.token) return false
      
      try {
        // 这里可以调用一个验证token的API
        // const res = await axios.get('/api/validate-token/')
        // 如果验证成功，可以更新用户信息
        // commit('updateUserInfo', res.data)
        return true
      } catch (error) {
        // token无效，清除登录状态
        commit('clearUser')
        return false
      }
    }
  },
  modules: {
    // 可以在这里添加更多的模块，如用户、设置等
  },
  // 添加Vuex插件来自动保存状态到localStorage
  plugins: [
    // 订阅所有mutation，在mutation执行后保存状态
    (store) => {
      store.subscribe((mutation, state) => {
        try {
          // 排除不需要持久化的状态
          const stateToPersist = {
            userId: state.userId,
            username: state.username,
            token: state.token,
            userInfo: state.userInfo
            // 不保存isLoading等临时状态
          }
          
          // 保存完整状态
          const serializedState = JSON.stringify(stateToPersist)
          localStorage.setItem(STORAGE_KEYS.STATE, serializedState)
        } catch (error) {
          console.error('保存状态失败:', error)
        }
      })
    }
  ]
})
